<template>
    <v-dialog v-model="show" :max-width="maxWidth" :persistent="persistent">
        <v-card>
            <!-- Header -->
            <v-card-title class="text-text"
                >{{ title }}
                <div
                    class="text-wrap text-textDarken text-body-2"
                    v-if="subtitle"
                >
                    {{ subtitle }}
                </div>
            </v-card-title>

            <!-- Content with grey background -->
            <v-card-text class="grey-bg pa-4 mt-4">
                <slot></slot>
            </v-card-text>

            <!-- Footer with actions -->
            <v-card-actions class="px-6 pb-4">
                <slot name="actions"></slot>
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>

<script setup>
import { computed } from "vue";

const props = defineProps({
    modelValue: {
        type: Boolean,
        default: false,
    },
    title: {
        type: String,
        required: true,
    },
    subtitle: {
        type: String,
        default: "",
    },
    maxWidth: {
        type: String,
        default: "600px",
    },
    persistent: {
        type: Boolean,
        default: true,
    },
});

const emit = defineEmits(["update:modelValue"]);

const show = computed({
    get: () => props.modelValue,
    set: (value) => emit("update:modelValue", value),
});
</script>

<style scoped>
.grey-bg {
    background-color: rgb(var(--v-theme-background));
}
</style>
